/**
 * Service Worker registration.
 *
 * Activo solo en producción. Se importa desde main.tsx y registra
 * el SW generado por vite-plugin-pwa con Workbox.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        console.log('[PWA] Service Worker registrado:', reg.scope);
      })
      .catch((err) => {
        console.warn('[PWA] Error registrando Service Worker:', err);
      });
  });
}
